<template>
    <div>
        <v-layout v-if="$vuetify.breakpoint.mdAndUp" column class="news-item item_page mb-4">
            <v-layout row>
                <v-flex v-if="content.image"
                        class="news__img-block"
                >
                    <v-layout align-center justify-center>
                        <img :src="content.image" alt="news image"
                             style="max-width: 200px"
                        >
                    </v-layout>
                </v-flex>
                <v-flex md9 ld9 xs8
                        class="pl-4"
                >
                    <v-layout column class="news_desc_cont">
                        <v-layout row wrap align-center
                                  class="news_dates_cont"
                        >
                            <labelTopic :class="label_class(content.type)" class="mr-2 mb-2">{{ $t(content.label) }}</labelTopic>
                            <v-flex v-if="content.date && typeof content.date == 'object'" class="news_dates mr-2 mb-2">
                                <div class=" font-weight-bold">{{ get_date(content.date[0]) }}</div>
                                <div class="mx-3"> - </div>
                                <div class=" font-weight-bold">{{ get_date(content.date[1]) }}</div>
                            </v-flex>
                            <v-flex v-else class="news_dates mb-2">
                                <div class=" font-weight-bold">{{ get_date(content.date) }}</div>
                            </v-flex>
                            <v-flex class="news_dates mb-2">
                                <iconLabel
                                  v-if='!isDataBase'
                                  :icon_name="content.liked ? 'heart-filled' : 'heart'"
                                  class=" icon-label-red label_news"
                                  size="20" @click.native="like_news(content.id)"
                                >
                                  {{ content.likes }}
                                </iconLabel>
                                <router-link
                                  v-if='!isDataBase'
                                  :to="{name: 'news_descript', params: {id: content.id}, hash:'#comments'}"
                                  class="link--anchor flex"
                                >
                                  <iconLabel
                                    v-if="content.label!='База знаний'"
                                    icon_name="chat" class="icon-label-green ml-4" size="20"
                                  >
                                    {{ content.comments }}
                                  </iconLabel>
                                </router-link>
                                <iconLabel
                                  :icon_name="content.favourite ? 'in-favorites' : 'favorites'"
                                  class="ml-4 pr-3 icon-label-red label_news" size="20"
                                  @click.native="wrapper_to_favourites(content)"
                                >
                                  {{ content.favourite ? $t('В избранном') : $t('В избранное') }}
                                </iconLabel>
                            </v-flex>
                        </v-layout>
                        <v-flex d-flex align-center
                                class="news__text pt-3"
                        >
                            <div>
                                <a class="default-text"><div class="news_title" @click="go_to_detail(content.id)">{{ content.title }}</div></a>
                                <div v-if="content.text" class="grey-text" v-html="content.text"></div>
                                <v-flex v-if="content.article" d-flex align-center
                                        class="news__article pa-4"
                                >
                                    <v-flex xs1>
                                        <svg v-svg
                                             symbol="book"
                                             class="news__icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex xs11>
                                        <darkLink>{{ content.article.text }}</darkLink>
                                    </v-flex>
                                </v-flex>
                            </div>
                        </v-flex>
                        <div v-if="content.registration == 'accepted'" class="mt-3"><linkIcon icon="cancel" @click.prevent="cancel_reg(content.id)">{{$t("Отменить регистрацию")}}</linkIcon></div>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-layout>


        <v-layout v-if="$vuetify.breakpoint.smAndDown" column class="news-item mb-4">
            <v-flex>
                <v-layout wrap align-center>
                    <v-flex>
                        <labelTopic :class="label_class">{{ $t(content.label) }}</labelTopic>
                    </v-flex>
                    <v-flex class="ml-2">
                        <v-flex v-if="typeof content.date == 'number'" class="news_dates mobile small">
                            <div class=" font-weight-bold">{{ get_date(content.date) }}</div>
                        </v-flex>
                        <v-flex v-else class="news_dates">
                            <div class=" font-weight-bold">{{ get_date(content.date[0]) }}</div>
                            <div class="mx-3"> - </div>
                            <div class=" font-weight-bold">{{ get_date(content.date[1]) }}</div>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-layout column>
                <v-flex md9 ld9 x8
                        xs8
                >
                    <v-layout column class="pa-3">
                        <v-layout row wrap align-center class="news_dates_cont">
                            <iconLabel
                              :icon_name="content.liked ? 'heart-filled' : 'heart'"
                              class=" icon-label-red label_new" size="20"
                            >
                              {{ content.likes }}
                            </iconLabel>
                            <router-link
                              v-if='!isDataBase'
                              :to="{name: 'news_descript', params: {id: content.id}, hash:'#comments'}"
                              class="link--anchor flex"
                            >
                              <iconLabel icon_name="chat" class="icon-label-green ml-2" size="20">
                                {{ content.comments }}
                              </iconLabel>
                            </router-link>
                            <iconLabel 
                              icon_name="content.favourite ? 'in-favorites' : 'favorites'"
                              class="ml-2 icon-label-red label_new" size="20"
                              @click.native="wrapper_to_favourites(content)"
                            >
                              {{ content.favourite ? $t('В избранном') : $t('В избранное') }}
                            </iconLabel>
                        </v-layout>
                        <v-flex d-flex align-center
                                class="news__text pt-4"
                        >
                            <div>
                                <div class="news_title" @click="go_to_detail(content.id)">{{ content.title }}</div>
                                <div v-if="content.text" class="grey-text" v-html="content.text"></div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-flex v-if="content.article" d-flex align-center
                    class="news__article pa-3"
            >
                <v-flex xs1 class="news_icon">
                    <svg v-svg
                         symbol="book"
                         class="news__icon"
                         role="presentation"
                    />
                </v-flex>
                <v-flex xs11 class="pl-2">
                    <darkLink :href="content.article.link">{{ content.article.text }}</darkLink>
                </v-flex>
            </v-flex>
            <div v-if="content.registration == 'accepted'" class="ma-3"><linkIcon icon="cancel" @click.prevent="cancel_reg(content.id)">{{$t("Отменить регистрацию")}}</linkIcon></div>
        </v-layout>
    </div>
</template>

<script>
import labelTopic from '@/components/ui/labels/label_topic';
import darkLink from '@/components/ui/links/styled/link_dark';
import iconLabel from '@/components/ui/icons/icon_with_label';
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import dayjs from 'dayjs';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);

export default {
  components: {
    labelTopic,
    darkLink,
    iconLabel,
    linkIcon,
  },
  props: {
    content: {
      type: Object
    }
  },
  computed: {
    ...mapState('favourites', ['tab']),
    ...mapGetters('news_main', ['news']),
    isDataBase() {
      return ['classification', 'products', 'oem', 'glossary'].includes(this.content.type)
    }
  },
  methods: {
    wrapper_to_favourites(content) {
      this.toggle_favourites(content);
      this.TOGGLE_NEWS_FAVOURITE(content.id);
    },
    ...mapActions('favourites', [
      'toggle_favourites',
      'remove_from_favourites',
    ]),
    ...mapActions('events', [
      'cancel_reg',
    ]),
    ...mapMutations('news_main', [
      'TOGGLE_NEWS_FAVOURITE',
    ]),
    ...mapActions('news_main', [
      'like_news',
    ]),
    get_date(date) {
      return new dayjs(date).format('DD.MM.YYYY');
    },
    get_time(date) {
      return new dayjs(date).format('HH.mm');
    },
    go_to_detail(id) {
      if (this.isDataBase) {
        this.$router.push({ name: 'database', query: { modalId: id, tab: this.content.type } })
      } else {
        this.$router.push({name: 'news_descript', params: { id}});
      }
    },
    label_class(type) {
      if (type == 'news') {
        return 'section-label--green';
      }
      if (type == 'events') {
        return 'section-label--grey';
      }
      if (type == 'actions') {
        return 'section-label--red';
      }
      if (type == 'marketing') {
        return 'section-label--blue';
      }
    },
  },
};
</script>
